import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core'
import { Router } from '@angular/router'
import { forkJoin } from 'rxjs'
import { GrowthToolkitClient, GrowthToolkitKPI, PracticeMetric, TaskItem } from 'src/app/shared/services/ppv.api'
import {
   ActionItemDataToSave,
   GrowthToolkitActionItemExpandableRowComponent,
} from '../action-item-expandable-row/action-item-expandable-row.component'

interface TaskItemAndMetric {
   task: TaskItem
   metric: PracticeMetric
}

@Component({
   selector: 'action-item-list',
   templateUrl: './action-item-list.component.html',
   styleUrls: ['./action-item-list.component.scss'],
   standalone: false,
})
export class GrowthToolkitActionItemListComponent implements OnInit {
   @ViewChildren(GrowthToolkitActionItemExpandableRowComponent) rowComponents!: QueryList<GrowthToolkitActionItemExpandableRowComponent>

   @Input() practiceSKeyNumber: number
   @Input() editable: boolean

   //this is the display object
   metricsToDisplay: TaskItemAndMetric[] = []

   kpiMap: { [key: number]: GrowthToolkitKPI }

   //prettier-ignore
   constructor(
      public router: Router,
      private growthToolkitClient: GrowthToolkitClient
    ) {}

   ngOnInit(): void {
      this.fetchData()
      this.fetchKPIs()

      //TODO: fetch the live "current" data for each task/action item row
   }

   fetchData(): void {
      forkJoin({
         metrics: this.growthToolkitClient.getMetricsForPractice(this.practiceSKeyNumber),
         tasksData: this.growthToolkitClient.getTasksData(),
      }).subscribe(({ metrics, tasksData }) => {
         //make a map for faster lookup of the metrics
         const metricMap = new Map<string, PracticeMetric>()
         metrics.forEach((metric) => {
            if (metric.taskId) {
               metricMap.set(metric.taskId, metric)
            }
            //console.log(metric)
         })

         //get the task items and metrics to display
         this.metricsToDisplay = tasksData.tasks
            .map((task) => {
               const matchingMetric = metricMap.get(task.id)
               if (matchingMetric) {
                  return { task, metric: matchingMetric }
               } else {
                  return { task, metric: { practiceSKey: this.practiceSKeyNumber, isActive: false, isPublished: false, startValue: 0 } }
               }
            })
            .filter((item): item is TaskItemAndMetric => {
               if (this.editable) return true //show if editable (the RM view)
               return item.metric.isActive && item.metric.isPublished //otherwise show if IsActive and IsPublished (the HM view)
            })
      })
   }

   fetchKPIs(): void {
      this.growthToolkitClient.getKPIs().subscribe((data) => {
         //populate the kpiDataMap for use in the html template
         this.kpiMap = data.reduce((acc, item) => {
            if (item.kpiId != null) {
               acc[item.kpiId] = item
            }
            return acc
         }, {} as { [key: number]: GrowthToolkitKPI })
      })
   }

   getActionItemsToSave(): ActionItemDataToSave[] {
      return this.rowComponents.map((row) => row.getActionItemDataToSave())
   }

   hasMetricsToDisplay(): boolean {
      return this.metricsToDisplay.length > 0
   }

   hasPublishedMetrics(): boolean {
      return this.metricsToDisplay.some((item) => item.metric.isPublished)
   }
}
